import { logError } from '@/utils/sentry';
import { onError } from '@apollo/client/link/error';

export const errorMiddleware = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      const graphQLError = new Error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
      );
      logError(graphQLError);
    });
  }

  if (networkError) {
    const error = new Error(`[Network error]: ${networkError}`);
    logError(error);
  }
});
